export default __webpack_public_path__ + "static/media/screen1.e1dace9a.png";